import React, { useState } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import Card from "../../../components/Card";
import { connect } from "react-redux";
import { getDarkMode } from "../../../store/mode";
import { useNavigate, useParams } from "react-router-dom";
import { useResetPasswordMutation } from "../../../api/authApiSlices";

function mapStateToProps(state) {
  return {
    darkMode: getDarkMode(state),
  };
}

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmationPassword, setConfirmationPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [resetPassword] = useResetPasswordMutation();

  const navigate = useNavigate();
  const { email, token } = useParams();

  const onResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    setMessage("");

    // Validate passwords match
    if (password !== confirmationPassword) {
      setError("Passwords do not match.");
      setIsLoading(false);
      return;
    }

    // Validate minimum password length
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      setIsLoading(false);
      return;
    }

    const payload = {
      email: email,
      password: password,
      password_confirmation: confirmationPassword,
      token: token
    };

    await resetPassword(payload)
      .unwrap()
      .then((res) => {
        setMessage("Password reset successfully! Redirecting to login...");
        setTimeout(() => {
          navigate("/auth/sign-in");
        }, 2000);
      })
      .catch((error) => {
        const errorMessage = error?.data?.message || "Failed to reset password. Please try again.";
        // Check for expiration error
        if (errorMessage.includes("expired")) {
          setError("This password reset link has expired. Please request a new one.");
        } else {
          setError(errorMessage);
        }
        console.error("Error resetting password:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <section className="login-content">
        <Container className="h-100">
          <Row className="align-items-center justify-content-center h-100">
            <Col md="5">
              <Card className="p-5">
                  <Card.Body>
                    <h3 className="mb-2 text-center">Reset Password</h3>
                    <p className="text-center small mb-3">
                      Enter your new password below
                    </p>
                    {message && (
                      <div className="alert alert-success text-center" role="alert">
                        {message}
                      </div>
                    )}
                    {error && (
                      <div className="alert alert-danger text-center" role="alert">
                        {error}
                      </div>
                    )}
                    <Form onSubmit={onResetPassword}>
                      <Row>
                        <Col lg="12">
                          <Form.Group>
                            <Form.Label>
                              New Password
                            </Form.Label>
                            <Form.Control
                              type="password"
                              placeholder="Enter Password (min 8 characters)"
                              required
                              minLength={8}
                              value={password}
                              onChange={(e) =>
                                setPassword(e.target.value)
                              }
                            />
                            <Form.Label className="mt-2">
                              Confirm Password
                            </Form.Label>
                            <Form.Control
                              type="password"
                              placeholder="Confirm Password"
                              required
                              value={confirmationPassword}
                              onChange={(e) =>
                                setConfirmationPassword(e.target.value)
                              }
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Button type="submit" className="btn btn-primary btn-block" disabled={isLoading}>
                        {isLoading ? "Resetting..." : "Reset Password"}
                      </Button>
                    </Form>
                  </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default connect(mapStateToProps)(ResetPassword);
